import React from 'react';
import TransferMarketTotals from './TransferMarketTotals';

function TransferMarketPanel({ show, onClose }) {
  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-50"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.9)",
        animation: "fadeIn 0.3s ease-out"
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="absolute top-0 left-0 right-0 backdrop-blur-2xl border-b"
        style={{
          backgroundColor: "rgba(17, 24, 39, 0.95)",
          borderColor: "rgba(168, 85, 247, 0.4)",
          boxShadow: "0 8px 40px rgba(168, 85, 247, 0.3)",
          maxHeight: "90vh",
          overflowY: "auto",
          animation: "slideDown 0.4s ease-out"
        }}
      >
        {/* Header */}
        <div
          className="sticky top-0 z-10 flex items-center justify-between px-8 py-5 border-b backdrop-blur-xl"
          style={{
            backgroundColor: "rgba(17, 24, 39, 0.9)",
            borderColor: "rgba(168, 85, 247, 0.3)"
          }}
        >
          <div className="flex items-center gap-4">
            <div
              className="w-12 h-12 rounded-xl flex items-center justify-center relative"
              style={{
                backgroundColor: "#a855f7",
                boxShadow: "0 0 30px rgba(168, 85, 247, 0.6)"
              }}
            >
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <div
                className="absolute inset-0 rounded-xl animate-ping opacity-75"
                style={{ backgroundColor: "#a855f7" }}
              />
            </div>
            <div>
              <h2 className="text-2xl font-black text-white">Transfer Market</h2>
              <p className="text-sm text-purple-400 font-semibold">رده‌بندی بر اساس خرید</p>
            </div>
          </div>

          <button
            onClick={onClose}
            className="w-11 h-11 rounded-xl flex items-center justify-center transition-all duration-200 hover:scale-110 hover:rotate-90 group"
            style={{
              backgroundColor: "rgba(239, 68, 68, 0.15)",
              border: "1px solid rgba(239, 68, 68, 0.3)"
            }}
          >
            <svg
              className="w-6 h-6 text-red-400 group-hover:text-red-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <TransferMarketTotals />
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes slideDown {
          from {
            transform: translateY(-100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}

export default TransferMarketPanel;